// src/config/creditCosts.js
const creditCosts = {
    ADD_RUN: 2,          // Cost for adding a new run
    LOAD_RUN: 2,         // Cost for loading a run
    SAVE_RUN: 5,         // Cost for saving a run
    SAVE_RUN_YOUTUBE: 15, // Cost for saving a run with YouTube upload
  };
  
  export default creditCosts;